import { z } from 'zod';

import type { GoogleStartRequest } from '@nucleus-commerce/api-client/platform';

import type { CodeMethod } from '../schemas/two-factor-rules';

/** Authenticator codes go out as six bare digits. */
export function toTotpCode(code: string): string {
  return code.replace(/\s+/g, '');
}

/** Recovery codes go out lower-cased with the hyphen, the way they were issued. */
export function toRecoveryCode(code: string): string {
  const compact = code.trim().toLowerCase();
  return compact.includes('-') ? compact : `${compact.slice(0, 4)}-${compact.slice(4)}`;
}

export function toChallengeCode(code: string, method: CodeMethod): string {
  return method === 'totp' ? toTotpCode(code) : toRecoveryCode(code);
}

/** The downloadable recovery-codes file: translated header lines, a blank line, one code per line. */
export function recoveryCodesText(header: readonly string[], codes: readonly string[]): string {
  return [...header, '', ...codes, ''].join('\n');
}

/** The typed email pre-selects the Google account when it looks like one. */
export function toGoogleStart(email: string): GoogleStartRequest {
  const hint = email.trim();
  return z.email().safeParse(hint).success ? { loginHint: hint } : {};
}
